import FeedbackListContainer from './container';
import FeedbackListView from './view';

export default FeedbackListContainer;
export { FeedbackListContainer, FeedbackListView };
